import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    //  TranslocoDirective
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class App {
  //protected title = 'Q8 Oils Business';

  constructor(private translocoService: TranslocoService) {}

  
}
